<template>
  <div class="gp-main-body-content">
    <DiscountBanner v-if="shopInfo.emailDiscountCode" :email="shopInfo.emailDiscountCode" />
    <ChrismastBanner v-else-if="shopInfo.christmasDiscount" />
    <header class="d-flex justify-content-between dashboard__header">
      <div v-if="firstName.length">
        <!-- Hello, {firstName}! -->
        <h2 class="heading-h2-24-semi text-light-high dashboard__hello">{{ helloMessage }}</h2>

        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="paragraph-14-regular text-dark6">
            <!-- Time to take store design and conversions to the next level! -->
            {{ helloMessageDesc }}
          </span>
        </div>
      </div>
      <div v-if="isGemPagesMixed" class="d-flex align-items-end">
        <div class="mr-2 dashboard__create v6 border-radius d-flex align-items-center"
          :class="{ active: createModalActive }">
          <div class="d-flex align-items-center dashboard__create-content no-border clickable" @click="toggleCreateModal"
            ref="createButton">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.625 4.375C10.625 4.02982 10.3452 3.75 10 3.75C9.65482 3.75 9.375 4.02982 9.375 4.375V9.375H4.375C4.02982 9.375 3.75 9.65482 3.75 10C3.75 10.3452 4.02982 10.625 4.375 10.625H9.375V15.625C9.375 15.9702 9.65482 16.25 10 16.25C10.3452 16.25 10.625 15.9702 10.625 15.625V10.625H15.625C15.9702 10.625 16.25 10.3452 16.25 10C16.25 9.65482 15.9702 9.375 15.625 9.375H10.625V4.375Z" fill="#212121"/>
            </svg>
            <span class="dashboard__create-txt-v6 paragraph-14-16-medium text-light1">{{ createNewTxt }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.13313 7.62204C5.31064 7.45932 5.59845 7.45932 5.77596 7.62204L10 11.4941L14.224 7.62204C14.4016 7.45932 14.6894 7.45932 14.8669 7.62204C15.0444 7.78476 15.0444 8.04858 14.8669 8.21129L10.3214 12.378C10.1439 12.5407 9.8561 12.5407 9.67859 12.378L5.13313 8.21129C4.95562 8.04858 4.95562 7.78476 5.13313 7.62204Z" fill="#212121"/>
            </svg>
          </div>
          <div class="dropdown mt-4px" v-if="createModalActive" ref="createModal" v-clickaway="closeCreateModal">
            <div class="bg-light1 border-radius p-1">
              <a @click.stop @click.prevent="onCreateNewPage('subpages')" class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 3.125C3.125 2.08947 3.96447 1.25 5 1.25H12.1998C12.7288 1.25 13.2332 1.47346 13.5886 1.86528L16.3888 4.95237C16.7017 5.29732 16.875 5.74637 16.875 6.21208V16.875C16.875 17.9105 16.0355 18.75 15 18.75H5C3.96447 18.75 3.125 17.9105 3.125 16.875V3.125ZM5 2.5C4.65482 2.5 4.375 2.77982 4.375 3.125V13.3589H15.625V6.5H12.4651C12.1199 6.5 11.8401 6.22018 11.8401 5.875V2.5H5ZM13.0901 3.17621V5.25H14.9711L13.0901 3.17621ZM4.375 16.875V14.6089H15.625V16.875C15.625 17.2202 15.3452 17.5 15 17.5H5C4.65482 17.5 4.375 17.2202 4.375 16.875Z" fill="#676767"/>
                  </svg>
                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.landingPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('homepages')" class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5729 1.40403C10.3334 1.18303 9.96442 1.18303 9.725 1.40403L1.6 8.90403C1.34637 9.13816 1.33055 9.53357 1.56468 9.78721C1.7988 10.0408 2.19422 10.0567 2.44785 9.82253L3.37525 8.96648V16.5282C3.37525 17.5637 4.21471 18.4032 5.25025 18.4032H15.0002C16.0358 18.4032 16.8752 17.5637 16.8752 16.5282V8.92276L17.85 9.82253C18.1036 10.0567 18.4991 10.0408 18.7332 9.78721C18.9673 9.53357 18.9515 9.13816 18.6979 8.90403L10.5729 1.40403ZM15.6257 7.76933L10.1489 2.71385L4.62525 7.81263V16.5282C4.62525 16.8734 4.90507 17.1532 5.25025 17.1532H6.97559L6.97559 13.5283C6.97559 12.4928 7.81506 11.6533 8.85059 11.6533H11.3506C12.3861 11.6533 13.2256 12.4928 13.2256 13.5283V17.1532H15.0002C15.3454 17.1532 15.6252 16.8734 15.6252 16.5282V7.79346C15.6252 7.78538 15.6254 7.77734 15.6257 7.76933ZM11.9756 17.1532H8.22559L8.22559 13.5283C8.22559 13.1831 8.50541 12.9033 8.85059 12.9033H11.3506C11.6958 12.9033 11.9756 13.1831 11.9756 13.5283V17.1532Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.homePages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('productpages')" class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.96509 11.3914C11.0045 11.3914 11.8261 11.0913 12.4595 10.6148C13.0849 10.1443 13.4928 9.52815 13.7593 8.94157C14.0257 8.35525 14.1608 7.77709 14.2301 7.35109C14.265 7.13655 14.2839 6.9566 14.2941 6.82816C14.2998 6.75662 14.3044 6.68489 14.306 6.61313L14.3061 6.6108C14.2301 5.88847 13.1353 5.78092 13.0563 6.58866C12.9772 7.39639 13.0562 6.59228 13.0562 6.59228C13.0562 6.59228 13.0559 6.59559 13.0553 6.6027C13.0501 6.66446 13.0233 6.98483 12.9963 7.15036C12.9385 7.50562 12.8282 7.96913 12.6213 8.42449C12.4145 8.87958 12.1213 9.30506 11.7081 9.61587C11.303 9.92061 10.7485 10.1414 9.96509 10.1414C9.18162 10.1414 8.63311 9.92067 8.23611 9.6182C7.83089 9.30946 7.54614 8.88641 7.34758 8.43254C7.14887 7.97836 7.04646 7.51565 6.99467 7.16057C6.96901 6.98463 6.95636 6.83915 6.95015 6.73977C6.94723 6.693 6.94489 6.6461 6.94425 6.59924C6.95836 5.75482 5.72304 5.75018 5.69425 6.60099C5.6944 6.65923 5.69625 6.71643 5.70259 6.81775C5.71062 6.94623 5.72645 7.12627 5.75776 7.34096C5.81991 7.76712 5.94536 8.34608 6.20238 8.93356C6.45954 9.52136 6.85839 10.14 7.47856 10.6125C8.10695 11.0913 8.92563 11.3914 9.96509 11.3914Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.12769 1.25C3.14057 1.25 2.32251 2.01534 2.25684 3.00028L1.34017 16.7503C1.26803 17.8325 2.1264 18.75 3.21102 18.75H16.7889C17.8735 18.75 18.7318 17.8325 18.6597 16.7503L17.743 3.00028C17.6774 2.01534 16.8593 1.25 15.8722 1.25H4.12769ZM3.50408 3.08343C3.52596 2.75511 3.79865 2.5 4.12769 2.5H15.8722C16.2012 2.5 16.4739 2.75511 16.4958 3.08343L17.4125 16.8334C17.4365 17.1942 17.1504 17.5 16.7889 17.5H3.21102C2.84948 17.5 2.56336 17.1942 2.58741 16.8334L3.50408 3.08343Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.productPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('collectionpages')" class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.875 3.375C1.875 2.54657 2.54657 1.875 3.375 1.875H7.6875C8.51593 1.875 9.1875 2.54657 9.1875 3.375V7.6875C9.1875 8.51593 8.51593 9.1875 7.6875 9.1875H3.375C2.54657 9.1875 1.875 8.51593 1.875 7.6875V3.375ZM3.375 3.125H7.6875C7.82557 3.125 7.9375 3.23693 7.9375 3.375V7.6875C7.9375 7.82557 7.82557 7.9375 7.6875 7.9375H3.375C3.23693 7.9375 3.125 7.82557 3.125 7.6875V3.375C3.125 3.23693 3.23693 3.125 3.375 3.125Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.875 12.3127C1.875 11.4843 2.54657 10.8127 3.375 10.8127H7.6875C8.51593 10.8127 9.1875 11.4843 9.1875 12.3127V16.6252C9.1875 17.4537 8.51593 18.1252 7.6875 18.1252H3.375C2.54657 18.1252 1.875 17.4537 1.875 16.6252V12.3127ZM3.375 12.0627H7.6875C7.82557 12.0627 7.9375 12.1747 7.9375 12.3127V16.6252C7.9375 16.7633 7.82557 16.8752 7.6875 16.8752H3.375C3.23693 16.8752 3.125 16.7633 3.125 16.6252V12.3127C3.125 12.1747 3.23693 12.0627 3.375 12.0627Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3125 1.875C11.4841 1.875 10.8125 2.54657 10.8125 3.375V7.6875C10.8125 8.51593 11.4841 9.1875 12.3125 9.1875H16.625C17.4534 9.1875 18.125 8.51593 18.125 7.6875V3.375C18.125 2.54657 17.4534 1.875 16.625 1.875H12.3125ZM16.625 3.125H12.3125C12.1744 3.125 12.0625 3.23693 12.0625 3.375V7.6875C12.0625 7.82557 12.1744 7.9375 12.3125 7.9375H16.625C16.7631 7.9375 16.875 7.82557 16.875 7.6875V3.375C16.875 3.23693 16.7631 3.125 16.625 3.125Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8125 12.3127C10.8125 11.4843 11.4841 10.8127 12.3125 10.8127H16.625C17.4534 10.8127 18.125 11.4843 18.125 12.3127V16.6252C18.125 17.4537 17.4534 18.1252 16.625 18.1252H12.3125C11.4841 18.1252 10.8125 17.4537 10.8125 16.6252V12.3127ZM12.3125 12.0627H16.625C16.7631 12.0627 16.875 12.1747 16.875 12.3127V16.6252C16.875 16.7633 16.7631 16.8752 16.625 16.8752H12.3125C12.1744 16.8752 12.0625 16.7633 12.0625 16.6252V12.3127C12.0625 12.1747 12.1744 12.0627 12.3125 12.0627Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name" :style="disableStarter">{{ createPageLabel.collectionPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('articlepages')" class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1662 1.93103C15.5316 1.29643 14.5027 1.29643 13.8681 1.93103L2.28619 13.5129C2.00283 13.7963 1.83416 14.1743 1.81259 14.5745L1.67428 17.141C1.63827 17.8092 2.18997 18.361 2.85817 18.325L5.42476 18.1867C5.82492 18.1651 6.20301 17.9964 6.48638 17.7131L18.0682 6.13121C18.7028 5.49661 18.7028 4.46771 18.0682 3.83311L16.1662 1.93103ZM14.7519 2.81491C14.8984 2.66847 15.1358 2.66847 15.2823 2.81491L17.1844 4.71699C17.3308 4.86344 17.3308 5.10088 17.1844 5.24732L14.9527 7.47895L12.5203 5.04654L14.7519 2.81491ZM11.4597 6.1072L3.17008 14.3968C3.10468 14.4622 3.06576 14.5494 3.06078 14.6418L2.92996 17.0693L5.3575 16.9385C5.44985 16.9335 5.5371 16.8946 5.60249 16.8292L13.8921 8.53961L11.4597 6.1072Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name" :style="disableStarter">{{ createPageLabel.articlePages.text }}</span>
                </div>
              </a>
              <!-- <hr class="bg-light3" />
              <div class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item" @click="toggleMoreTypes">
                <div class="d-flex align-items-center justify-content-between">
                  <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="8.00012" r="1" fill="#1E232F" />
                    <circle cx="8" cy="8.00012" r="1" fill="#1E232F" />
                    <circle cx="13" cy="8.00012" r="1" fill="#1E232F" />
                  </svg>
                  <span class="ml-1 paragraph-14-16-regular name">{{ moreCreateTypeTxt }}</span>
                </div>
                <i class="icon" :class="showCreateMoreTypes ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
              </div> -->
            </div>
          </div>
        </div>
        <!-- For release mixed user with landing page -->
        <ImageToLayoutCreatePage fromPage="GP_STATIC" />
      </div>
      <div v-else class="d-flex align-items-end">
        <!-- Pending: Move Widget on Page -->
        <!-- <div class="border-radius bg-primary-300 py-1 px-2 mr-3 clickable" v-if="openCustom">
          <span class="paragraph-14-medium text-light1">Add Widget</span>
        </div> -->

        <!-- <div class="border-radius d-flex justify-content-center align-items-center clickable dashboard__custome-icon"
          v-popover:tooltip.top="'Customize Dashboard'" @click="showCustom">
          <i class="icon icon-customize text-light-high"></i>
        </div> -->
        <div class="ml-1 dashboard__create border-radius d-flex align-items-center" :class="{ active: createModalActive }">
          <div class="d-flex align-items-center dashboard__create-content px-2 no-border clickable" @click="toggleCreateModal" ref="createButton">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.1252 1.94922C11.1252 1.60404 10.8454 1.32422 10.5002 1.32422C10.1551 1.32422 9.87524 1.60404 9.87524 1.94922V9.37524H2.44922C2.10404 9.37524 1.82422 9.65507 1.82422 10.0002C1.82422 10.3454 2.10404 10.6252 2.44922 10.6252H9.87524V18.0512C9.87524 18.3964 10.1551 18.6762 10.5002 18.6762C10.8454 18.6762 11.1252 18.3964 11.1252 18.0512V10.6252H18.5512C18.8964 10.6252 19.1762 10.3454 19.1762 10.0002C19.1762 9.65507 18.8964 9.37524 18.5512 9.37524H11.1252V1.94922Z" fill="white" />
            </svg>
            <span class="dashboard__create-txt px-1 paragraph-14-16-medium text-light1">{{ createNewTxt }}</span>

            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.63313 7.62204C5.81064 7.45932 6.09845 7.45932 6.27596 7.62204L10.5 11.4941L14.724 7.62204C14.9016 7.45932 15.1894 7.45932 15.3669 7.62204C15.5444 7.78476 15.5444 8.04858 15.3669 8.21129L10.8214 12.378C10.6439 12.5407 10.3561 12.5407 10.1786 12.378L5.63313 8.21129C5.45562 8.04858 5.45562 7.78476 5.63313 7.62204Z" fill="white" />
            </svg>
          </div>

          <div class="dropdown mt-4px" v-if="createModalActive" ref="createModal" v-clickaway="closeCreateModal">
            <div class="bg-light1 border-radius">
              <a @click.stop @click.prevent="onCreateNewPage('subpages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 3.125C3.125 2.08947 3.96447 1.25 5 1.25H12.1998C12.7288 1.25 13.2332 1.47346 13.5886 1.86528L16.3888 4.95237C16.7017 5.29732 16.875 5.74637 16.875 6.21208V16.875C16.875 17.9105 16.0355 18.75 15 18.75H5C3.96447 18.75 3.125 17.9105 3.125 16.875V3.125ZM5 2.5C4.65482 2.5 4.375 2.77982 4.375 3.125V13.3589H15.625V6.5H12.4651C12.1199 6.5 11.8401 6.22018 11.8401 5.875V2.5H5ZM13.0901 3.17621V5.25H14.9711L13.0901 3.17621ZM4.375 16.875V14.6089H15.625V16.875C15.625 17.2202 15.3452 17.5 15 17.5H5C4.65482 17.5 4.375 17.2202 4.375 16.875Z" fill="#676767"/>
                  </svg>
                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.landingPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('homepages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5729 1.40403C10.3334 1.18303 9.96442 1.18303 9.725 1.40403L1.6 8.90403C1.34637 9.13816 1.33055 9.53357 1.56468 9.78721C1.7988 10.0408 2.19422 10.0567 2.44785 9.82253L3.37525 8.96648V16.5282C3.37525 17.5637 4.21471 18.4032 5.25025 18.4032H15.0002C16.0358 18.4032 16.8752 17.5637 16.8752 16.5282V8.92276L17.85 9.82253C18.1036 10.0567 18.4991 10.0408 18.7332 9.78721C18.9673 9.53357 18.9515 9.13816 18.6979 8.90403L10.5729 1.40403ZM15.6257 7.76933L10.1489 2.71385L4.62525 7.81263V16.5282C4.62525 16.8734 4.90507 17.1532 5.25025 17.1532H6.97559L6.97559 13.5283C6.97559 12.4928 7.81506 11.6533 8.85059 11.6533H11.3506C12.3861 11.6533 13.2256 12.4928 13.2256 13.5283V17.1532H15.0002C15.3454 17.1532 15.6252 16.8734 15.6252 16.5282V7.79346C15.6252 7.78538 15.6254 7.77734 15.6257 7.76933ZM11.9756 17.1532H8.22559L8.22559 13.5283C8.22559 13.1831 8.50541 12.9033 8.85059 12.9033H11.3506C11.6958 12.9033 11.9756 13.1831 11.9756 13.5283V17.1532Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.homePages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('productpages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.96509 11.3914C11.0045 11.3914 11.8261 11.0913 12.4595 10.6148C13.0849 10.1443 13.4928 9.52815 13.7593 8.94157C14.0257 8.35525 14.1608 7.77709 14.2301 7.35109C14.265 7.13655 14.2839 6.9566 14.2941 6.82816C14.2998 6.75662 14.3044 6.68489 14.306 6.61313L14.3061 6.6108C14.2301 5.88847 13.1353 5.78092 13.0563 6.58866C12.9772 7.39639 13.0562 6.59228 13.0562 6.59228C13.0562 6.59228 13.0559 6.59559 13.0553 6.6027C13.0501 6.66446 13.0233 6.98483 12.9963 7.15036C12.9385 7.50562 12.8282 7.96913 12.6213 8.42449C12.4145 8.87958 12.1213 9.30506 11.7081 9.61587C11.303 9.92061 10.7485 10.1414 9.96509 10.1414C9.18162 10.1414 8.63311 9.92067 8.23611 9.6182C7.83089 9.30946 7.54614 8.88641 7.34758 8.43254C7.14887 7.97836 7.04646 7.51565 6.99467 7.16057C6.96901 6.98463 6.95636 6.83915 6.95015 6.73977C6.94723 6.693 6.94489 6.6461 6.94425 6.59924C6.95836 5.75482 5.72304 5.75018 5.69425 6.60099C5.6944 6.65923 5.69625 6.71643 5.70259 6.81775C5.71062 6.94623 5.72645 7.12627 5.75776 7.34096C5.81991 7.76712 5.94536 8.34608 6.20238 8.93356C6.45954 9.52136 6.85839 10.14 7.47856 10.6125C8.10695 11.0913 8.92563 11.3914 9.96509 11.3914Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.12769 1.25C3.14057 1.25 2.32251 2.01534 2.25684 3.00028L1.34017 16.7503C1.26803 17.8325 2.1264 18.75 3.21102 18.75H16.7889C17.8735 18.75 18.7318 17.8325 18.6597 16.7503L17.743 3.00028C17.6774 2.01534 16.8593 1.25 15.8722 1.25H4.12769ZM3.50408 3.08343C3.52596 2.75511 3.79865 2.5 4.12769 2.5H15.8722C16.2012 2.5 16.4739 2.75511 16.4958 3.08343L17.4125 16.8334C17.4365 17.1942 17.1504 17.5 16.7889 17.5H3.21102C2.84948 17.5 2.56336 17.1942 2.58741 16.8334L3.50408 3.08343Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name">{{ createPageLabel.productPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('collectionpages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.875 3.375C1.875 2.54657 2.54657 1.875 3.375 1.875H7.6875C8.51593 1.875 9.1875 2.54657 9.1875 3.375V7.6875C9.1875 8.51593 8.51593 9.1875 7.6875 9.1875H3.375C2.54657 9.1875 1.875 8.51593 1.875 7.6875V3.375ZM3.375 3.125H7.6875C7.82557 3.125 7.9375 3.23693 7.9375 3.375V7.6875C7.9375 7.82557 7.82557 7.9375 7.6875 7.9375H3.375C3.23693 7.9375 3.125 7.82557 3.125 7.6875V3.375C3.125 3.23693 3.23693 3.125 3.375 3.125Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.875 12.3127C1.875 11.4843 2.54657 10.8127 3.375 10.8127H7.6875C8.51593 10.8127 9.1875 11.4843 9.1875 12.3127V16.6252C9.1875 17.4537 8.51593 18.1252 7.6875 18.1252H3.375C2.54657 18.1252 1.875 17.4537 1.875 16.6252V12.3127ZM3.375 12.0627H7.6875C7.82557 12.0627 7.9375 12.1747 7.9375 12.3127V16.6252C7.9375 16.7633 7.82557 16.8752 7.6875 16.8752H3.375C3.23693 16.8752 3.125 16.7633 3.125 16.6252V12.3127C3.125 12.1747 3.23693 12.0627 3.375 12.0627Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3125 1.875C11.4841 1.875 10.8125 2.54657 10.8125 3.375V7.6875C10.8125 8.51593 11.4841 9.1875 12.3125 9.1875H16.625C17.4534 9.1875 18.125 8.51593 18.125 7.6875V3.375C18.125 2.54657 17.4534 1.875 16.625 1.875H12.3125ZM16.625 3.125H12.3125C12.1744 3.125 12.0625 3.23693 12.0625 3.375V7.6875C12.0625 7.82557 12.1744 7.9375 12.3125 7.9375H16.625C16.7631 7.9375 16.875 7.82557 16.875 7.6875V3.375C16.875 3.23693 16.7631 3.125 16.625 3.125Z" fill="#676767"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8125 12.3127C10.8125 11.4843 11.4841 10.8127 12.3125 10.8127H16.625C17.4534 10.8127 18.125 11.4843 18.125 12.3127V16.6252C18.125 17.4537 17.4534 18.1252 16.625 18.1252H12.3125C11.4841 18.1252 10.8125 17.4537 10.8125 16.6252V12.3127ZM12.3125 12.0627H16.625C16.7631 12.0627 16.875 12.1747 16.875 12.3127V16.6252C16.875 16.7633 16.7631 16.8752 16.625 16.8752H12.3125C12.1744 16.8752 12.0625 16.7633 12.0625 16.6252V12.3127C12.0625 12.1747 12.1744 12.0627 12.3125 12.0627Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name" :style="disableStarter">{{ createPageLabel.collectionPages.text }}</span>
                </div>
              </a>
              <a @click.stop @click.prevent="onCreateNewPage('articlepages')" class="px-2 py-10px d-flex align-items-center justify-content-between dropdown__item">
                <div class="d-flex align-items-center">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1662 1.93103C15.5316 1.29643 14.5027 1.29643 13.8681 1.93103L2.28619 13.5129C2.00283 13.7963 1.83416 14.1743 1.81259 14.5745L1.67428 17.141C1.63827 17.8092 2.18997 18.361 2.85817 18.325L5.42476 18.1867C5.82492 18.1651 6.20301 17.9964 6.48638 17.7131L18.0682 6.13121C18.7028 5.49661 18.7028 4.46771 18.0682 3.83311L16.1662 1.93103ZM14.7519 2.81491C14.8984 2.66847 15.1358 2.66847 15.2823 2.81491L17.1844 4.71699C17.3308 4.86344 17.3308 5.10088 17.1844 5.24732L14.9527 7.47895L12.5203 5.04654L14.7519 2.81491ZM11.4597 6.1072L3.17008 14.3968C3.10468 14.4622 3.06576 14.5494 3.06078 14.6418L2.92996 17.0693L5.3575 16.9385C5.44985 16.9335 5.5371 16.8946 5.60249 16.8292L13.8921 8.53961L11.4597 6.1072Z" fill="#676767"/>
                  </svg>

                  <span class="ml-1 paragraph-14-16-regular name" :style="disableStarter">{{ createPageLabel.articlePages.text }}</span>
                </div>
              </a>
              <!-- <hr class="bg-light3" />
              <div class="pl-1 pr-2 py-12px d-flex align-items-center justify-content-between dropdown__item" @click="toggleMoreTypes">
                <div class="d-flex align-items-center justify-content-between">
                  <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="3" cy="8.00012" r="1" fill="#1E232F" />
                    <circle cx="8" cy="8.00012" r="1" fill="#1E232F" />
                    <circle cx="13" cy="8.00012" r="1" fill="#1E232F" />
                  </svg>
                  <span class="ml-1 paragraph-14-16-regular name">{{ moreCreateTypeTxt }}</span>
                </div>
                <i class="icon" :class="showCreateMoreTypes ? 'icon-arrow-up' : 'icon-arrow-down'"></i>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container mt-5">
      <div class="row">
        <div class="col-8 pl-0 pr-2">
          <StoreOnlineThemeChange :theme-name="shopifyDefaultTheme.name" @close="closePanelThemeChange"
            v-if="isShowPanelThemeChange && isGemPagesV7" />
          <TrialTooltipPlanVue />
          <GemAIBanner v-if="isShowGemAIBanner" />
          <template v-if="leftSections.filter(item => item.show).length">
            <ExpiredTrial />
            <components v-for="(item, index) in displayedLeftSections" :key="index" :is="getComponent(item.name)" />
          </template>
          <template v-else>
            <SectionPlaceholder side="left" @add-widget="showCustom" />
            <ExpiredTrial />
          </template>
        </div>
        <div class="col-4 pr-0 pl-2">
          <!-- Pending: Move Widget on Page -->
          <!-- <div class="d-flex justify-content-center align-items-center dashboard__placeholder" v-if="openCustom">
            <span class="body-14-regular txt-dark-disabled text-center text__right"> When you add a new small widget, it will appear here </span>
          </div> -->
          <!-- <Community></Community> -->
          <!-- <SurveyOnboard></SurveyOnboard> -->
          <template v-if="rightSections.filter(item => item.show).length">
            <components v-for="(item, index) in rightSections.filter(item => item.show)" :key="index" :is="getComponent(item.name)" />
          </template>
          <template v-else>
            <SectionPlaceholder side="right" @add-widget="showCustom" />
          </template>
        </div>
      </div>
    </div>

    <Modal v-if="openCustom" :active="openCustom" mClass="p-0 border-radius custom" padding="p-0" @cancel="closeCustom" @container="closeCustom">
      <template #default>
        <div class="custom__modal">
          <!-- Header -->
          <div class="custom__modal-header d-flex align-items-center bg-light1 px-4 position-relative">
            <p class="text-lightmode heading-h3-20-medium mr-4px">{{ $t("dashboard.customTitle") }}</p>
            <div class="gp_modal-close p-1" @click="closeCustom"><i class="text-light-high icon icon-cancel"></i></div>
          </div>
          <div class="custom__container" ref="customContainer">
            <!-- Main -->
            <div class="bg-light1 p-4 pt-3" @mousemove="dragFunction">
              <div class="p-2 custom__tips bg-info d-flex align-items-center justify-content-between border-radius mb-3" v-if="showGotItCustom">
                <div class="d-flex align-items-center">
                  <i class="icon icon-infor-fill" />
                  <span class="ml-1 txt-dark-low-contrast body-14-regular">{{ $t("dashboard.customGotItText") }}</span>
                </div>
                <i class="icon icon-cancel" @click="clickGotIt" />
              </div>

              <div class="d-flex justify-content-between">
                <div class="custom__col">
                  <p class="text-dark-low body-12-regular custom__col-title">{{ $t("dashboard.leftSection") }}</p>

                  <div class="mt-2">
                    <div v-for="(item, i) in customLeftSections" :key="`left-${i}`" class="custom__item" :class="customItemDynamicClass(item, i)" ref="leftItems">
                      <div class="bg-light-grey-400 border-radius custom__placeholder" v-if="dragFrom && dragFrom.side == 'left' && dragFrom.i == i">&nbsp;</div>
                      <div class="bg-light1 border-radius custom__item-body" @mousedown="e => startDrag(item, i, e, 'left')">
                        <i class="icon icon-drag custom__drag-icon" />

                        <div class="d-flex align-items-center custom__item-body-content ml-2">
                          <i class="icon text-light-high" :class="customItemsMap[item.name].icon" />
                          <span class="ml-12px body-14-medium text-light-high">{{ customItemsMap[item.name].title }}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center custom__switch clickable" v-if="!(dragFrom && dragFrom.side == 'left' && dragFrom.i == i)" @click="e => toggleCustomItem(item, e)">
                        <Toggler v-model="item.show" small :disabled="item.disabled" />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="custom__col">
                  <p class="text-dark-low body-12-regular custom__col-title">{{ $t("dashboard.rightSection") }}</p>
                  <div class="mt-2">
                    <div v-for="(item, i) in customRightSections" :key="`right-${i}`" class="border-radius custom__item" :class="customItemDynamicClass(item, i)" ref="rightItems">
                      <div class="bg-light-grey-400 border-radius custom__placeholder" v-if="dragFrom && dragFrom.side == 'right' && dragFrom.i == i">&nbsp;</div>
                      <div class="bg-light1 border-radius custom__item-body" @mousedown="e => startDrag(item, i, e, 'right')">
                        <i class="icon icon-drag custom__drag-icon" />

                        <div class="d-flex align-items-center custom__item-body-content ml-2">
                          <i class="icon text-light-high" :class="customItemsMap[item.name].icon" />
                          <span class="ml-12px body-14-medium text-light-high">{{ customItemsMap[item.name].title }}</span>
                        </div>
                      </div>
                      <div class="d-flex align-items-center custom__switch clickable" v-if="!(dragFrom && dragFrom.side == 'right' && dragFrom.i == i)" @click="e => toggleCustomItem(item, e)">
                        <Toggler v-model="item.show" small :disabled="item.disabled" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="custom__modal-footer bg-light1 px-4 py-3 d-flex flex-row-reverse">
            <div :disabled="saveCustomStatus == 'disabled'" class="border-radius body-14-medium py-1 px-2 clickable ml-1 custom__save" :class="saveCustomDynamicClass" @click="clickSaveCustom" v-html="saveCustomText"></div>
            <div class="border-radius txt-dark-high-contrast d-flex align-items-center px-3 clickable custom__reset" @click="resetCustom">
              <p class="paragraph-14-16-medium">{{ $t("storeSettings.eventLogs.searchForm.reset") }}</p>
            </div>
          </div>
        </div>
        <div class="custom__drag" :style="dragDynamicStyle" v-if="dragRect" @mouseup="finishDrag" @mousemove="dragFunction">
          <div class="bg-light1 py-2 pr-2 pl-4 border-radius custom__drag-body">
            <i class="icon icon-drag custom__drag-icon" />
            <div class="d-flex justify-content-between align-items-center ml-1">
              <div class="d-flex align-items-center custom__drag-body-content">
                <icon class="icon" :class="customItemsMap[dragFrom.item.name].icon" />
                <span class="ml-12px body-14-medium txt-dark-high-contrast">{{ customItemsMap[dragFrom.item.name].title }}</span>
              </div>
              <div class="d-flex align-items-center">
                <Toggler v-model="dragFrom.item.show" small :disabled="dragFrom.item.disabled" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <SurveyReasonNotUpgrading />
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */

import { NotiBar, DiscountBanner, ChrismastBanner } from "@/core/components";
import RecentPage from "./RecentPage.vue";
import NewTemplate from "./NewTemplate.vue";
import SurveyOnboard from "./SurveyOnBoard/Index";
import SurveyReasonNotUpgrading from "./SurveyReasonNotUpgrading/Index";
import Community from "./Community.vue";
import Support from "./Support.vue";
import Banner from "./Banner.vue";
import Blog from "./Blog.vue";
import Faqs from "./Faqs.vue";
import TopIntegrations from "./TopIntegrations.vue";
import QuickStartGuide from "./QuickStartGuide.vue";
import ExpiredTrial from "./ExpiredTrial.vue";
import ChangeLog from "./ChangeLog.vue";
import SectionPlaceholder from "./SectionPlaceholder.vue";
import TrialTooltipPlanVue from "@/modules/Pricing/components/TrialTooltipPlan.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import Cookie from "@/utils/cookie";
import { DASHBOARD_EVENT } from "@/config/constants/trackEventIds";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
import { createThemeAndPageV7 } from "@/modules/Instant/utils";
import initGemPagesV7 from "@/mixins/initGemPagesV7.js";
import StoreOnlineThemeChange from "./StoreOnlineThemeChange.vue";
import { getShopMetaByKey, META_KEY_GENERATOR_CONFIG, shopMetaCreateOrUpdateDocument } from "@/services/meta";
import { getShopifyDefaultTheme } from "@/services/global-style";
import ImageToLayoutCreatePage from "./ImageToLayoutCreatePage.vue";
import GemAIBanner from "./GemAIBanner.vue";

const ComponentsMap = {
  recentPages: "RecentPage",
  newTemplates: "NewTemplate",
  support: "Support",
  banner: "Banner",
  blog: "Blog",
  faqs: "Faqs",
  topIntegrations: "TopIntegrations",
  changelog: "ChangeLog",
  quickStartGuide: "QuickStartGuide"
};

const cloneArray = array => {
  return JSON.parse(JSON.stringify(array));
};

const compareArray = (array1, array2) => {
  return JSON.stringify(array1) === JSON.stringify(array2);
};

export default {
  name: "NewDashboard",
  components: {
    NotiBar,
    ImageToLayoutCreatePage,
    RecentPage,
    NewTemplate,
    Support,
    Banner,
    Blog,
    Faqs,
    TopIntegrations,
    QuickStartGuide,
    ExpiredTrial,
    ChangeLog,
    SectionPlaceholder,
    DiscountBanner,
    ChrismastBanner,
    SurveyOnboard,
    SurveyReasonNotUpgrading,
    TrialTooltipPlanVue,
    Community,
    StoreOnlineThemeChange,
    GemAIBanner
  },
  mixins: [dynamicTriggerContent(), initGemPagesV7],
  data: () => ({
    showCreateMoreTypes: false,
    dragRect: null,
    dragging: false,
    dragFrom: null,
    dragList: [],
    currentCustomLeftSections: [],
    currentCustomRightSections: [],
    saveCustomStatus: "disabled",
    showGotItCustom: false,
    createModalActive: false,
    isShowPanelThemeChange: false,
    themeGSConfig: {},
    shopifyDefaultTheme: {
      name: ""
    }
  }),
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo",
      instantShopId: "instantShopId"
    }),
    ...mapState({
      permission: state => {
        return state.account.permissions;
      }
    }),
    ...mapGetters("account", {
      shopPlan: "shopPlan",
      firstName: "accountFirstName",
      shopifyDomain: "shopifyDomain",
      displayLanguage: "displayLanguage"
    }),
    ...mapGetters("dashboard", {
      leftSections: "leftSections",
      rightSections: "rightSections",
      openCustom: "openCustom",
      loadingDashboard: "loading",
      firstCallGetApi: "firstCallGetApi"
    }),
    starterPlan() {
      return this.shopPlan === "starter";
    },
    disableEventStarter() {
      // if (this.shopPlan === "starter") {
      //   return {
      //     "pointer-events": "none"
      //   }
      // }

      return {};
    },
    disableStarter() {
      return {};
    },
    helloMessageDesc() {
      return this.$t("dashboard.helloMessageDesc");
    },
    createNewTxt() {
      return this.$t("dashboard.createNewPageTxt");
    },
    moreCreateTypeTxt() {
      return this.showCreateMoreTypes ? this.$t("dashboard.lessTypes") : this.$t("dashboard.moreTypes");
    },
    helloMessage() {
      return this.$t("dashboard.helloMessage", { name: this.firstName });
    },
    dragDynamicStyle() {
      let style = {};
      if (this.dragRect) {
        style.top = `${this.dragRect.top}px`;
        style.left = `${this.dragRect.left}px`;
        style.width = `${this.dragRect.width}px`;
        style.height = `${this.dragRect.height}px`;
      }

      return style;
    },
    isShowGemAIBanner(){
      const otherBanner = this.displayedLeftSections.filter(item => item.show).find(item => item.name === "banner");
      return (this.isGemPagesV7 || this.isGemPagesMixed) && !otherBanner && !this.isShowPanelThemeChange
    },
    isGemPagesMixed() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesMixed) || window.___gemShopInfo.shopType.isGemPagesMixed || false;
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesV7) || window.___gemShopInfo.shopType.isGemPagesV7 || false;
    },
    displayedLeftSections() {
      if (this.isGemPagesV7) {
        return this.leftSections.filter(item => item.show && item.name !== "quickStartGuide");
      }
      return this.leftSections.filter(item => item.show);
    },
    customLeftSections() {
      if (this.dragging && this.dragFrom.side == "left") {
        return this.dragList;
      }

      if (this.isGemPagesV7) {
        return this.currentCustomLeftSections.filter(section => section.name !== "quickStartGuide");
      }
      return this.currentCustomLeftSections;
    },
    customRightSections() {
      if (this.dragging && this.dragFrom.side == "right") {
        return this.dragList;
      }
      return this.currentCustomRightSections;
    },
    customItemsMap() {
      return {
        recentPages: {
          title: this.$t("dashboard.recentPages"),
          icon: "icon-recent"
        },
        newTemplates: {
          title: this.$t("dashboard.newTemplates"),
          icon: "icon-new-template"
        },
        support: {
          title: this.$t("dashboard.support"),
          icon: "icon-help"
        },
        banner: {
          title: this.$t("dashboard.banner"),
          icon: "icon-banner"
        },
        blog: {
          title: this.$t("dashboard.blog"),
          icon: "icon-report"
        },
        faqs: {
          title: this.$t("dashboard.news"),
          icon: "icon-news"
        },
        topIntegrations: {
          title: this.$t("integration.title"),
          icon: "icon-new-intergration"
        },
        changelog: {
          title: this.$t("dashboard.changelog"),
          icon: "icon-changelog"
        },
        quickStartGuide: {
          title: this.$t("dashboard.quickStartGuide"),
          icon: "icon-checklist"
        }
      };
    },
    saveCustomDynamicClass() {
      return [this.saveCustomStatus];
    },
    saveCustomText() {
      switch (this.saveCustomStatus) {
        case "loading":
          return /*html */ `<span class="loader">&nbsp;</span>`;
        case "success":
          return this.$t("generals.success");
        case "error":
          return this.$t("generals.error");
        default:
          return this.$t("dashboard.saveChanges");
      }
    },
    createPageLabel() {
      return {
        landingPages: {
          text: this.$t("page.landingPages1"),
          number: this.$t("dashboard.numberOfLoadingPages")
        },
        homePages: {
          text: this.$t("dashboard.homePage"),
          number: this.$t("dashboard.numberOfHomePages")
        },
        productPages: {
          text: this.$t("dashboard.productPage"),
          number: this.$t("dashboard.numberOfProductPages")
        },
        collectionPages: {
          text: this.$t("dashboard.collectionPage"),
          number: this.$t("dashboard.numberOfCollectionPages")
        },
        articlePages: {
          text: this.$t("dashboard.articlePage"),
          number: this.$t("dashboard.numberOfArticlePages")
        }
      };
    }
  },
  watch: {
    instantShopId: {
      handler: async function() {
        const res = await getShopMetaByKey(META_KEY_GENERATOR_CONFIG);
        if (res?.data?.shopMetaByKey?.value) {
          this.themeGSConfig = JSON.parse(res?.data?.shopMetaByKey?.value);
          this.isShowPanelThemeChange = this.themeGSConfig?.notificationThemeChange ?? false;
          const themeChange = await getShopifyDefaultTheme();
          this.shopifyDefaultTheme = themeChange.data.shopifyDefaultTheme;
        }
      },
      immediate: true
    }
  },
  async created() {
    await this.init();
    const themeInf = await getShopifyDefaultTheme();
    if (themeInf.data) {
      this.shopifyDefaultTheme = themeInf.data.shopifyDefaultTheme;
    }

    const res = await getShopMetaByKey(META_KEY_GENERATOR_CONFIG);
    if (res?.data?.shopMetaByKey?.value) {
      this.themeGSConfig = JSON.parse(res?.data?.shopMetaByKey?.value);
      this.isShowPanelThemeChange = this.themeGSConfig?.notificationThemeChange ?? false;
    }
  },
  methods: {
    ...mapActions("dashboard", {
      putSettings: "putSettings",
      getAllDashboardData: "getAllDashboardData"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapActions("page", {
      createPageWithOneTap: "createPageWithOneTap"
    }),
    async closePanelThemeChange() {
      this.isShowPanelThemeChange = false;
      await shopMetaCreateOrUpdateDocument(META_KEY_GENERATOR_CONFIG, {
        ...this.themeGSConfig,
        notificationThemeChange: false
      });
    },
    trackCreateNewEvent(pageType) {
      let eventId = null;
      let properties = {};

      switch (pageType) {
        case "landing":
          eventId = DASHBOARD_EVENT.CREATE_LANDING_PAGE_CLICKED;
          properties.text = this.createPageLabel.landingPages.text;
          break;
        case "home":
          eventId = DASHBOARD_EVENT.CREATE_HOME_PAGE_CLICKED;
          properties.text = this.createPageLabel.homePages.text;
          break;
        case "product":
          eventId = DASHBOARD_EVENT.CREATE_PRODUCT_PAGE_CLICKED;
          properties.text = this.createPageLabel.productPages.text;
          break;
        case "collection":
          eventId = DASHBOARD_EVENT.CREATE_COLLECTION_PAGE_CLICKED;
          properties.text = this.createPageLabel.collectionPages.text;
          break;
        case "blogpost":
          eventId = DASHBOARD_EVENT.CREATE_BLOG_POST_CLICKED;
          properties.text = this.createPageLabel.articlePages.text;
          break;
      }

      this.trackEvent({ event_id: eventId, properties: properties });
    },

    async init() {
      const shouldHaveLoading = !this.firstCallGetApi;
      await this.getAllDashboardData(shouldHaveLoading);
      const gotItCustomCookie = Cookie.get("GotItCustom");
      if (gotItCustomCookie) {
        const domainArray = JSON.parse(gotItCustomCookie);
        if (domainArray.includes(this.shopifyDomain)) {
          this.showGotItCustom = false;
        } else {
          this.showGotItCustom = true;
        }
      } else {
        this.showGotItCustom = true;
      }
    },
    getComponent(key) {
      return ComponentsMap[key];
    },
    toggleMoreTypes() {
      this.showCreateMoreTypes = !this.showCreateMoreTypes;
    },
    showCustom() {
      if (this.loadingDashboard) return;
      this.resetCustom();
      this.$store.commit("dashboard/TOGGLE_CUSTOM", true);
    },
    resetCustom() {
      this.currentCustomLeftSections = cloneArray(this.leftSections);
      this.currentCustomRightSections = cloneArray(this.rightSections);
      this.saveCustomStatus = "disabled";
    },
    closeCustom() {
      this.currentCustomLeftSections = [];
      this.currentCustomRightSections = [];
      this.saveCustomStatus = "disabled";
      this.$store.commit("dashboard/TOGGLE_CUSTOM", false);
    },
    customItemDynamicClass(item, i) {
      return {
        "mt-1": i > 0,
        "allow-hover": !this.dragging
      };
    },
    startDrag(item, i, e, side = "left") {
      e.preventDefault();
      e.stopPropagation();
      this.dragFrom = { item, i, side };

      let elementRect = null;
      if (side == "left") {
        elementRect = this.$refs.leftItems[i].getBoundingClientRect();
        this.dragList = cloneArray(this.currentCustomLeftSections);
      } else {
        elementRect = this.$refs.rightItems[i].getBoundingClientRect();
        this.dragList = cloneArray(this.currentCustomRightSections);
      }

      const rect = {
        top: elementRect.top,
        left: elementRect.left,
        width: elementRect.width,
        height: elementRect.height,
        clientX: e.clientX,
        clientY: e.clientY
      };

      this.dragRect = rect;
      this.dragging = true;
    },
    dragFunction(event) {
      event.preventDefault();
      if (this.dragging) {
        event = event || window.event;
        let touchLocation = null;
        let moveX = 0;
        let moveY = 0;

        if (event.type === "touchmove") {
          touchLocation = event.targetTouches[0];
          moveX = this.dragRect.clientX - touchLocation.pageX;
          moveY = this.dragRect.clientY - touchLocation.pageY;
        } else {
          moveX = this.dragRect.clientX - event.clientX;
          moveY = this.dragRect.clientY - event.clientY;
        }

        this.dragRect.clientX = event.clientX || touchLocation.pageX;
        this.dragRect.clientY = event.clientY || touchLocation.pageY;

        const currentMinX = this.dragRect.left - moveX;
        const currentMinY = this.dragRect.top - moveY;
        const currentMaxX = currentMinX + this.dragRect.width;
        const currentMaxY = currentMinY + this.dragRect.height;

        const customContainer = this.$refs.customContainer;
        const customContainerRect = customContainer.getBoundingClientRect();
        const containerMinY = customContainerRect.top;
        const containerMaxY = customContainerRect.top + customContainerRect.height;

        const aboveFooter = currentMinY < containerMinY;
        const belowFooter = currentMaxY > containerMaxY;

        if (aboveFooter || belowFooter) {
          const step = 5 * moveY;
          customContainer.scrollTop -= step;
        }

        const checkHtmlIntersect = (element, i) => {
          if (i != this.dragFrom.i) {
            const rect = element.getBoundingClientRect();
            const minX = rect.left;
            const maxX = minX + rect.width;
            const minY = rect.top;
            const maxY = minY + rect.height;

            const aLeftOfB = currentMaxX < minX;
            const aRightOfB = currentMinX > maxX;
            const aAboveB = currentMaxY < minY;
            const aBelowB = currentMinY > maxY;

            const aOutOfB = aLeftOfB || aRightOfB || aAboveB || aBelowB;

            if (!aOutOfB) {
              const item = this.dragList[this.dragFrom.i];
              this.dragList.splice(this.dragFrom.i, 1);
              this.dragList.splice(i, 0, item);
              this.dragFrom.i = i;
            }
          }
        };

        if (this.dragFrom.side == "left") {
          this.$refs.leftItems.forEach(checkHtmlIntersect);
        } else {
          this.$refs.rightItems.forEach(checkHtmlIntersect);
        }

        this.dragRect.left = currentMinX;
        this.dragRect.top = currentMinY;
      }
    },
    finishDrag() {
      if (this.dragging) {
        if (this.dragFrom.side == "left") {
          this.currentCustomLeftSections = cloneArray(this.dragList);
        } else {
          this.currentCustomRightSections = cloneArray(this.dragList);
        }

        this.dragRect = null;
        this.dragging = false;
        this.dragFrom = null;
        this.dragList = [];
        this.checkCustomChange();
      }
    },
    toggleCustomItem(item, e) {
      e.preventDefault();
      e.stopPropagation();

      if (item.disabled) return;

      item.show = !item.show;
      this.checkCustomChange();
    },
    checkCustomChange() {
      const leftCheck = compareArray(this.leftSections, this.currentCustomLeftSections);
      const rightCheck = compareArray(this.rightSections, this.currentCustomRightSections);
      this.saveCustomStatus = leftCheck && rightCheck ? "disabled" : "";
    },
    saveCustomSuccess() {
      this.saveCustomStatus = "success";
      setTimeout(() => {
        this.saveCustomStatus = "";
      }, "1000");
    },
    saveCustomError() {
      this.saveCustomStatus = "error";
      setTimeout(() => {
        this.saveCustomStatus = "";
      }, "1000");
    },
    async clickSaveCustom() {
      if (this.saveCustomStatus != "") return;

      try {
        this.saveCustomStatus = "loading";
        const left = cloneArray(this.currentCustomLeftSections);
        const right = cloneArray(this.currentCustomRightSections);

        await this.putSettings({
          left,
          right
        });

        this.saveCustomSuccess();
        this.closeCustom();
      } catch (err) {
        this.saveCustomError();
      }
    },
    clickGotIt() {
      const gotItCustomCookie = Cookie.get("GotItCustom");
      if (gotItCustomCookie) {
        const domainArray = JSON.parse(gotItCustomCookie);
        if (!domainArray.includes(this.shopifyDomain)) {
          domainArray.push(this.shopifyDomain);
          Cookie.set("GotItCustom", JSON.stringify(domainArray));
        }
      } else {
        const domainArray = [this.shopifyDomain];
        Cookie.set("GotItCustom", JSON.stringify(domainArray));
      }
      this.showGotItCustom = false;
    },
    toggleCreateModal() {
      this.trackEvent({ event_id: DASHBOARD_EVENT.CREATE_NEW_CLICKED, properties: { text: this.createNewTxt } });

      if (this.loadingDashboard) return;
      this.createModalActive = !this.createModalActive;
    },
    closeCreateModal(e) {
      if (e && this.$refs.createModal && this.$refs.createButton && this.createModalActive) {
        const currentX = e.pageX;
        const currentY = e.pageY;
        const createModalRect = this.$refs.createModal.getBoundingClientRect();
        const mouseInCreateModal = currentX >= createModalRect.left && currentX <= createModalRect.left + createModalRect.width && currentY >= createModalRect.top && currentY <= createModalRect.top + createModalRect.height;
        const createButtonRect = this.$refs.createButton.getBoundingClientRect();
        const mouseInCreateButton = currentX >= createButtonRect.left && currentX <= createButtonRect.left + createButtonRect.width && currentY >= createButtonRect.top && currentY <= createButtonRect.top + createButtonRect.height;

        if (!mouseInCreateModal && !mouseInCreateButton) {
          this.createModalActive = false;
        }
      }
    },
    async onCreateNewPage(pageType) {
      if (this.isGemPagesV7) {
        await createThemeAndPageV7({ pageType });
        return;
      }

      const { productpages, collectionpages, articlepages } = this.permission;
      let options = null;
      if (pageType === "productpages" && !productpages) {
        options = {
          name: "PricingOnboarding",
          params: {
            id: this.patIdsPricingOnboard.product
          }
        };
      }

      if (pageType === "collectionpages" && !collectionpages) {
        options = {
          name: "PricingOnboarding",
          params: {
            id: this.patIdsPricingOnboard.collection
          }
        };
      }

      if (pageType === "articlepages" && !articlepages) {
        options = {
          name: "PricingOnboarding",
          params: {
            id: this.patIdsPricingOnboard.blog
          }
        };
      }
      if (options) {
        return this.$router.push(options);
      }
      this.createPageWithOneTap({ type: pageType });
      return false;
    }
  }
};
</script>

<style lang="scss">
$padding: 5px;
$dot-faq: 3.75px;

@mixin position-Y-center {
  top: 50%;
  transform: translateY(-50%);
}

.dashboard {
  &__header {
    max-height: 64px;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  &__hello {
    margin-bottom: 4px;
  }

  &__custome {
    &-icon {
      width: 40px;
      height: 40px;
      font-size: 20px;
      background: $light1;

      &:hover {
        background: $textDarkModeHigh;
      }
    }
  }

  &__link {
    color: map-get($primary-blue, "300");

    &-txt {
      margin-right: 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: map-get($primary-blue, "300");

      &:hover {
        text-decoration-line: underline;
        color: map-get($primary-blue, "325");
      }
    }

    &-icon {
      font-size: 16px;
      color: map-get($primary-blue, "300");
    }
  }

  &__create {
    background-color: $mono3;
    position: relative;
    height: 40px;

    border-radius: 3px;

    &.v6 {
      background-color: #f4f4f4;
    }

    &-content {
      height: 100%;
      padding: 16px 9.5px;
    }

    &-icon {
      font-size: 20px;
    }

    &-txt {
      line-height: 16px !important;
    }

    &-txt-v6 {
      color: #212121;
      margin: 0px 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 150% !important;
    }

    .dropdown {
      position: absolute;
      top: calc(100%);
      right: 0;
      z-index: 10;
      width: 100%;
      border-radius: 3px;
      @include shadow-hover;
      .power-by {
        justify-content: center !important;
        border-top: 1px solid rgba(73, 73, 73, 0.1);
        margin-top: 8px;

        span {
          font-weight: 400;
          font-size: 12px;
          line-height: 150%;
          color: #676767;
          margin-right: 3px;
        }
      }
      &__item {
        background-color: $light1;
        cursor: pointer;
        height: 40px;

        &:first-child {
          border-radius: 3px 3px 0 0;
        }

        &:last-child {
          border-radius: 0 0 3px 3px;
        }

        .name {
          color: $textLightModeHigh;
        }

        &:hover {
          background-color: map-get($light-grey, "500");
        }
      }
    }

    &:hover {
      background-color: $mono4;

      &.v6 {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    &:active {
      background-color: $mono4;

      &.v6 {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  &__placeholder {
    border-radius: 5px;
    height: 72px;
    border: 1px dashed map-get($light-text, "subtext");

    .text {
      &__right {
        max-width: 264px;
      }
    }
  }

  &__template {
    &-btn {
      width: calc(50% - 5px);
    }

    &-overlay {
      position: absolute;
      background: $shade8;
      border-radius: 0px 0px 3px 3px;
      padding: 11px;
      margin-top: auto;
      width: 100%;
      bottom: -55px;
      z-index: 1;
      transition-duration: 0.3s;

      .template-item:hover & {
        bottom: 0;
      }

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: $light3;
      }

      .icon {
        font-size: 12px;
        line-height: 12px;
        margin-left: 3px;
      }

      &_item-name {
        color: #212121;
      }

      &_tag-name {
        color: #757575;
      }
    }
  }

  &__link {
    &-icon {
      path {
        fill: map-get($dark-text-new, "low-contrast");
      }
    }

    &:hover {
      color: map-get($primary, "300");

      .dashboard__link {
        &-text {
          color: map-get($primary, "200");
        }

        &-icon {
          path {
            fill: map-get($primary, "200");
          }
        }
      }
    }
  }

  &__faq {
    &-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      max-height: 3rem;
      width: 100%;
      -webkit-line-clamp: 2;
    }

    &-read {
      color: map-get($dark-text, "disabled");
    }

    &-dot {
      color: map-get($dark-text, "disabled");
      font-size: $dot-faq;
      margin-left: 10.12px;
      margin-right: 10.12px;
    }
  }
}

.section__actions {
  @include trans-all;
  height: 32px;
  background: $light3;
  border-radius: 3px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: $textDarkModeHigh;
  }
}

.custom {
  &.gp_modal-container_body {
    max-height: none;
  }

  &__modal {
    width: 848px;
    position: relative;

    .icon-cancel {
      font-size: 16px;
      color: $textLightModeHigh;
    }
  }

  &__btn {
    background-color: $light2;

    &:hover {
      background-color: map-get($light-grey, "100");
    }
  }

  &__container {
    max-height: calc(100vh - 160px);
    overflow: auto;
  }

  &__tooltip {
    position: relative;

    .content,
    .arrow {
      @include position-Y-center;
      position: absolute;
      display: none;
    }

    &:hover {
      .arrow {
        display: block;
      }

      .content {
        display: flex;
      }
    }

    .content {
      left: calc(100% + 8px);
      width: max-content;
      max-width: 420px;
    }

    .arrow {
      left: calc(100% + 4px);
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-right: 4px solid map-get($dark-blue, "300");
    }
  }

  &__reset {
    border: 1px solid $dark5;
    color: $textLightModeHigh;

    &:hover {
      border-color: $dark7;
      background-color: $textDarkModeHigh;
    }
  }

  &__save {
    color: $light1;
    background-color: $mono3;

    &:hover {
      background-color: $mono4;
    }

    &.disabled {
      color: $textLightModeDisabled;
      background-color: $neutral7;
      cursor: no-drop;
    }

    &.loading {
      .loader {
        border: 4px solid map-get($light-text, "high-contrast");
        border-radius: 50%;
        border-top: 4px solid map-get($dark-text-new, "disabled");
        width: 22px;
        height: 22px;
        -webkit-animation: spin 2s linear infinite;
        /* Safari */
        animation: spin 2s linear infinite;
        display: block;
      }

      /* Safari */
      @-webkit-keyframes spin {
        0% {
          -webkit-transform: rotate(0deg);
        }

        100% {
          -webkit-transform: rotate(360deg);
        }
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }
    }

    &.success {
      color: map-get($accent-green-new, "200");
      background-color: map-get($accent-green-new, "500");
    }

    &.error {
      color: map-get($accent-pink, "200");
      background-color: map-get($accent-pink, "500");
    }
  }

  &__col {
    width: calc(50% - 27px);

    &-title {
      letter-spacing: 0.25px;
    }
  }

  &__drag {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    cursor: grabbing;
    border: solid 1px $neutral7;
    border-radius: 3px;

    &-body {
      position: relative;
      width: 100%;
      height: 100%;
      user-select: none;
      background-color: $light2;

      &-content {
        .icon {
          font-size: 20px;
        }
      }
    }

    &-icon {
      position: absolute;
      color: $dark6;
      left: 16px;
      @include position-Y-center;

      .custom__item & {
        display: none;
      }
    }
  }

  &__item {
    cursor: grab;
    position: relative;
    user-select: none;

    &-body {
      background-color: $light2;
      padding: 16px 14px 16px 24px;
      height: 52px;

      &-content {
        .icon {
          font-size: 20px;
        }
      }
    }

    &.allow-hover {
      &:hover {
        .custom__drag-icon {
          display: block;
        }
      }
    }
  }

  &__placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $light6;
  }

  &__switch {
    position: absolute;
    top: 6px;
    right: 14px;
    height: 100%;
    z-index: 1;
    width: 40px;
    height: 40px;
    margin-top: auto;
    margin-bottom: auto;
    top: 0;
    bottom: 0;
    text-align: center;
    justify-content: center;

    &-label {
      width: 4ch;

      &.fr {
        width: 6ch;
      }
    }
  }
}

.slide {
  &__list {
    flex-wrap: nowrap;
    transition-property: transform;
    transition-duration: 1.5s;
    transition-timing-function: cubic-bezier(0, 0.005, 0.39, 1);
  }
}

.custom__modal {
  &-header {
    height: 72px;
    border-bottom: solid 1px $textDarkModeHigh;
  }

  &-footer {
    height: 89px;
    border-top: solid 1px $textDarkModeHigh;
  }

  .gp_modal-close {
    top: 20px !important;
    right: 24px !important;
  }
}

.custom__container {
  .custom__tips {
    .icon-infor-fill {
      font-size: 20px;
      color: $primaryBlue350;
    }

    .icon-cancel {
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
